import { RoutePage } from "@/components/RoutePage";
import { TeamSection } from "@/components/sections/TeamSection";

export default function TeamPage({ onOpenContact, onRequestDossier }) {
  return (
    <RoutePage
      kicker="The Team"
      badge="TM"
      accent="#38BDF8"
      title="Scientists, clinicians, engineers, and operators. Privately."
      intro="Eight founding roles spanning neuroscience, clinical medicine, molecular therapeutics, AI, aerospace engineering, business, and biomedical innovation. Identities are held back at this stage; full dossier is available to qualified partners under NDA."
      primaryCta="Request team dossier"
      secondaryCta={{ href: "/research", label: "Read the science" }}
      onOpenContact={onRequestDossier || onOpenContact}
      prev={{ href: "/applications", label: "Applications" }}
      next={{ href: "/research", label: "Research" }}
      meta={{
        title: "Team",
        description:
          "Neurobolt.AI's founding team — anonymized at this stage, spanning neuroscience, medicine, molecular therapeutics, AI, and engineering. Full dossier available under NDA.",
        path: "/team",
      }}
      stats={[
        { k: "8", v: "Leadership roles" },
        { k: "~200", v: "Publications" },
        { k: ">$30M", v: "Funding history" },
        { k: "NDA", v: "Identity gate" },
      ]}
    >
      <TeamSection onRequestDossier={onRequestDossier} />
    </RoutePage>
  );
}
